import React from 'react';
import { Box, Typography } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DeleteIcon from '@mui/icons-material/Delete';
import Loader from '../../../../../components/Loader';

const ManageFieldsRight = ({ fields, onDragEnd, dragAndDropIcon, onClose, CustomButton, onSave, isLoading, handleDeleteCustomField }) => (
  <Box className="manage-fields-right">
    {isLoading ?
      <div className="loader-center">
        <Loader color={"black"} />
      </div> :
      <>
        <Box className="manage-fields-drag-list">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="fields-droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {fields.map((item, idx) => (
                    <Draggable key={item.id} draggableId={item.id} index={idx}>
                      {(provided, snapshot) => (
                        <Box
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={`manage-fields-drag-item${snapshot.isDragging ? ' dragging' : ''}`}
                          sx={{
                            '&:hover .delete-icon': {
                              opacity: 1,
                            },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                            <span {...provided.dragHandleProps} className="manage-fields-drag-handle">
                              <img src={dragAndDropIcon} alt="drag" />
                            </span>
                            <Typography className="manage-fields-drag-label">{item.name}</Typography>
                          </Box>
                          {item.field_type === 'custom' && <DeleteIcon
                            className="delete-icon"
                            sx={{
                              opacity: 0,
                              transition: 'opacity 0.2s',
                              cursor: 'pointer',
                              color: 'error.main',
                              '&:hover': {
                                color: 'error.dark',
                              },
                            }}
                            onClick={(e) => {
                              handleDeleteCustomField(item.custom_field_id);
                            }}
                          />}
                        </Box>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Box>
        <Box className="manage-fields-actions">
            <CustomButton
              variant="outlined"
              onClick={onClose}
              className="manage-fields-cancel-btn"
            >
              Cancel
            </CustomButton>
            <CustomButton
              variant="contained"
              type="button"
              className="manage-fields-save-btn"
              onClick={onSave}
              disabled={isLoading}
            >
              Save
            </CustomButton>
          </Box>
      </>}
  </Box>
);

export default ManageFieldsRight; 